import type { ResourceLanguage } from 'i18next'

import account from './account.json'
import alerts from './alerts.json'
import asyncUpdates from './asyncUpdates.json'
import auth from './auth.json'
import automations from './automations.json'
import campaigns from './campaigns.json'
import categoryPerformance from './categoryPerformance.json'
import cogs from './cogs.json'
import common from './common.json'
import dashboards from './dashboards.json'
import distributionAnalysis from './distributionAnalysis.json'
import filters from './filters.json'
import goals from './goals.json'
import homePage from './homePage.json'
import insights from './insights.json'
import metrics from './metrics.json'
import navigation from './navigation.json'
import productCatalog from './productCatalog.json'
import segments from './segments.json'
import settings from './settings.json'
import sov from './sov.json'
import table from './table.json'
import widgets from './widgets.json'

const en: ResourceLanguage = {
    account,
    alerts,
    asyncUpdates,
    auth,
    automations,
    campaigns,
    categoryPerformance,
    cogs,
    common,
    dashboards,
    distributionAnalysis,
    filters,
    goals,
    homePage,
    insights,
    metrics,
    navigation,
    productCatalog,
    segments,
    settings,
    table,
    widgets,
    sov,
}

export default en
